<template>
  <div>
    <div class="text-center">Tabel 1. Rata-rata Persentase Pengelolaan Dana BOS SMA 2017</div>
    <br>
    <table style="width: 100%" class="table table-bordered">
      <thead>
        <tr>
          <th class="text-center"></th>
          <th class="text-center">1</th>
          <th class="text-center">2</th>
          <th class="text-center">3</th>
          <th class="text-center">4</th>
          <th class="text-center">5</th>
          <th class="text-center">6</th>
          <th class="text-center">7</th>
        </tr>
      </thead>
      <tbody class="text-center">
        <tr>
          <td>Rerata Prov Sultra</td>
          <td>99.5%</td>
          <td>88.14%</td>
          <td>70.81%</td>
          <td>84.74%</td>
          <td>51.88%</td>
          <td>58.34%</td>
          <td>99.5%</td>
        </tr>
      </tbody>
    </table>

    <div id="tabel_1"></div>
    <div class="text-center h_cetak_1">
      <i>Grafik 1. Rata-rata Persentase Pengelolaan Dana BOS SMA 2017</i>
    </div>
  </div>
</template>



<script>
const ADD_URL = URL_APP + "api/v1/instrumen_guru/";
import uniqid from "uniqid";

export default {
  name: "monev_instrumen_guru",
  data: function() {
    return {
      ada: "ada"
    };
  },

  methods: {
    tabel_1: function() {
      var data = google.visualization.arrayToDataTable([
        ["Opening Move", "Percentage", { role: "annotation" }],
        ["1", 99.5, 99.5],
        ["2", 88.14, 88.14],
        ["3", 70.81, 70.81],
        ["4", 84.74, 84.74],
        ["5", 51.88, 51.88],
        ["6", 58.34, 58.34],
        ["7", 99.5, 99.5]
      ]);

      var options = {
        title: "RERATA PENGELOLAAN",
        bar: { groupWidth: "60%" },
        legend: "none",
        vAxis: {minValue: 0},
        height:350,
        backgroundColor: '#E4E4E4',
      };

      var chart_div = document.getElementById("tabel_1");
      var chart = new google.visualization.ColumnChart(chart_div);

      // Wait for the chart to finish drawing before calling the getImageURI() method.
      google.visualization.events.addListener(chart, "ready", function() {
        chart_div.innerHTML = '<img src="' + chart.getImageURI() + '">';
        // console.log(chart_div.innerHTML);
      });

      chart.draw(data, options);
    }
  },

  // =============================================================== METHODS =========================================================================

  mounted() {
    google.charts.load("current", {packages:['corechart']});
    google.charts.setOnLoadCallback(this.tabel_1);
    // google.charts.setOnLoadCallback(this.tabel_2);
  }
};
</script>
